import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: '/dashboard', title: 'ダッシュボード(Dashboard)', icon: 'dashboard', class: '' },
  { path: '/orders', title: 'オーダ(Orders)', icon: 'list', class: '' },
  { path: '/customers', title: 'カスタマー (Customers)', icon: 'supervised_user_circle', class: '' },
  { path: '/stores', title: '店舗(Stores)', icon: 'store', class: '' },
  { path: '/order-rating-and-review', title: 'カスタマーレビュー(Order Rating & Review)', icon: 'star_rate', class: '' },
  // { path: '/returns-and-refunds', title: 'Returns & Refunds', icon: 'remove_shopping_cart', class: '' },
  // { path: '/subscribers', title: 'Subscribers', icon: 'mark_email_read', class: '' },
  // { path: '/serviceability', title: 'Serviceability', icon: 'storefront', class: '' },
  { path: '/configurations', title: '設定(Configurations)', icon: 'storefront', class: '' },
  { path: '/users-list', title: 'ユーザーリスト(UsersList)', icon: 'supervised_user_circle', class: '' },
  // { path: '/user-profile', title: 'User Profile', icon: 'person_pin', class: '' },
];


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  selectedScrennsList: any;
  showThisScreenWithPermissions: any;
  permissionForOnlyThisScreenDashboard = [];
  permissionForOnlyThisScreenOrders = [];
  permissionForOnlyThisScreenStores_Management = [];
  permissionForOnlyThisScreenOrder_Rating_and_Review = [];
  permissionForOnlyThisScreenConfigurations = [];
  permissionForOnlyThisScreenUser_Management = [];
  permissionForOnlyThisScreenCustomers = [];
  permissionForOnlyThisScreencarts = [];
  permissionForOnlyThisScreenReports = [];
  ThisScreenDashboard: any;
  ThisScreencarts: any;
  ThisScreenCustomers: any;
  ThisScreenUser_Management: any;
  ThisScreenConfigurations: any;
  ThisScreenSubscription: any;
  ThisScreenReturns_and_Refunds: any;
  ThisScreenOrder_Rating_and_Review: any;
  ThisScreenStores_Management: any;
  ThisScreenOrders: any;
  ThisScreenReports: any;
  constructor() { 
    this.showThisScreenWithPermissions = JSON.parse(localStorage.getItem('screensList'));
    console.log(this.showThisScreenWithPermissions);

    for (var i = 0; i < this.showThisScreenWithPermissions.screens.length; i++) {
      if (this.showThisScreenWithPermissions.screens[i].screen_name === "ダッシュボード") {
        var forOrders = {
          "screen_id": this.showThisScreenWithPermissions.screens[i].screen_id,
          "screen_name": this.showThisScreenWithPermissions.screens[i].screen_name,
          "is_read": this.showThisScreenWithPermissions.screens[i].is_read,
          "is_write": this.showThisScreenWithPermissions.screens[i].is_write
        }
        this.permissionForOnlyThisScreenDashboard.push(forOrders);
      }
      if (this.showThisScreenWithPermissions.screens[i].screen_name === "オーダ") {
        var forOrders = {
          "screen_id": this.showThisScreenWithPermissions.screens[i].screen_id,
          "screen_name": this.showThisScreenWithPermissions.screens[i].screen_name,
          "is_read": this.showThisScreenWithPermissions.screens[i].is_read,
          "is_write": this.showThisScreenWithPermissions.screens[i].is_write
        }
        this.permissionForOnlyThisScreenOrders.push(forOrders);
      }
      if (this.showThisScreenWithPermissions.screens[i].screen_name === "出荷店舗の管理") {
        var forOrders = {
          "screen_id": this.showThisScreenWithPermissions.screens[i].screen_id,
          "screen_name": this.showThisScreenWithPermissions.screens[i].screen_name,
          "is_read": this.showThisScreenWithPermissions.screens[i].is_read,
          "is_write": this.showThisScreenWithPermissions.screens[i].is_write
        }
        this.permissionForOnlyThisScreenStores_Management.push(forOrders);
      }
      if (this.showThisScreenWithPermissions.screens[i].screen_name === "カスタマーレビュー") {
        var forOrders = {
          "screen_id": this.showThisScreenWithPermissions.screens[i].screen_id,
          "screen_name": this.showThisScreenWithPermissions.screens[i].screen_name,
          "is_read": this.showThisScreenWithPermissions.screens[i].is_read,
          "is_write": this.showThisScreenWithPermissions.screens[i].is_write
        }
        this.permissionForOnlyThisScreenOrder_Rating_and_Review.push(forOrders);
      }
      if (this.showThisScreenWithPermissions.screens[i].screen_name === "設定") {
        var forOrders = {
          "screen_id": this.showThisScreenWithPermissions.screens[i].screen_id,
          "screen_name": this.showThisScreenWithPermissions.screens[i].screen_name,
          "is_read": this.showThisScreenWithPermissions.screens[i].is_read,
          "is_write": this.showThisScreenWithPermissions.screens[i].is_write
        }
        this.permissionForOnlyThisScreenConfigurations.push(forOrders);
      }
      if (this.showThisScreenWithPermissions.screens[i].screen_name === "ユーザー管理") {
        var forOrders = {
          "screen_id": this.showThisScreenWithPermissions.screens[i].screen_id,
          "screen_name": this.showThisScreenWithPermissions.screens[i].screen_name,
          "is_read": this.showThisScreenWithPermissions.screens[i].is_read,
          "is_write": this.showThisScreenWithPermissions.screens[i].is_write
        }
        this.permissionForOnlyThisScreenUser_Management.push(forOrders);
      }
      if (this.showThisScreenWithPermissions.screens[i].screen_name === "カスタマー") {
        var forOrders = {
          "screen_id": this.showThisScreenWithPermissions.screens[i].screen_id,
          "screen_name": this.showThisScreenWithPermissions.screens[i].screen_name,
          "is_read": this.showThisScreenWithPermissions.screens[i].is_read,
          "is_write": this.showThisScreenWithPermissions.screens[i].is_write
        }
        this.permissionForOnlyThisScreenCustomers.push(forOrders);
      }
      if (this.showThisScreenWithPermissions.screens[i].screen_name === "カート") {
        var forOrders = {
          "screen_id": this.showThisScreenWithPermissions.screens[i].screen_id,
          "screen_name": this.showThisScreenWithPermissions.screens[i].screen_name,
          "is_read": this.showThisScreenWithPermissions.screens[i].is_read,
          "is_write": this.showThisScreenWithPermissions.screens[i].is_write
        }
        this.permissionForOnlyThisScreencarts.push(forOrders);
      }
    }
    console.log(this.permissionForOnlyThisScreenDashboard[0]);
    this.ThisScreenDashboard = this.permissionForOnlyThisScreenDashboard[0];
    this.ThisScreenOrders = this.permissionForOnlyThisScreenOrders[0];
    this.ThisScreenStores_Management = this.permissionForOnlyThisScreenStores_Management[0];
    this.ThisScreenOrder_Rating_and_Review = this.permissionForOnlyThisScreenOrder_Rating_and_Review[0];
    this.ThisScreenConfigurations = this.permissionForOnlyThisScreenConfigurations[0];
    this.ThisScreenUser_Management = this.permissionForOnlyThisScreenUser_Management[0];
    this.ThisScreenCustomers = this.permissionForOnlyThisScreenCustomers[0];
    this.ThisScreencarts = this.permissionForOnlyThisScreencarts[0];
    this.ThisScreenReports = this.permissionForOnlyThisScreenReports[0];
  }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };
}
